import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ProductSort } from 'src/app/models/Home/home-list.model';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { ResetSidebarService } from 'src/app/services/reset-sidebar.service';
import { HomePageComponent } from '../home-page/home-page.component';

@Component({
  selector: 'app-shop-header',
  templateUrl: './shop-header.component.html',
  styleUrls: ['./shop-header.component.css']
})
export class ShopHeaderComponent implements OnInit {
  @Output() newProductEvent = new EventEmitter<string>();
  name: string;
  @Input('searchBar') searchBar: string;
  tokenName: string;
  pagingModel: PagingModel = new PagingModel();
  homeContentList: ProductSort = new ProductSort();
  totalPages: number;

  constructor(private _resetSidebar: ResetSidebarService, private localstorage: LocalstorageService, private homePageService: HomePageService, private router: Router) {
    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }
  }
  async ngOnInit() {
    this.name = this.localstorage.getname();
    if(this.name == "null" || this.name == "undefined"){
      this.name = "";
    }
     this.tokenName = localStorage.getItem('loginToken');
    if (this.tokenName) {
      document.querySelector("#divLoader").className = "show";
    } else {
      document.querySelector("#divLoader").className = "hide";
    }
    this.searchBar = this.localstorage.getSearchKeyword();
    if (this.searchBar) {
      await localStorage.setItem('searchBar', this.searchBar);
      this.addProductItem(this.searchBar);
      this.router.navigate(['/home-page']);
    }
  }

  addProductItem(value: string) {
    this.newProductEvent.emit(value);
  }

  logout() {
    localStorage.removeItem('loginToken');
    this.localstorage.logout();
    this.localstorage.changeLoginStatus(false);
    this.router.navigate(['/home-page']);
    this.ngOnInit();
  }

  searchProduct(e) {
    if (e.keyCode == 13) {
      this.searchBar;
      localStorage.setItem('searchBar', this.searchBar);
      this.addProductItem(this.searchBar);
      this.router.navigate(['/home-page']);
    }
 
  }
  searchProductItems() {
    this.searchBar;
    localStorage.setItem('searchBar', this.searchBar);
    this.addProductItem(this.searchBar);
    this.router.navigate(['/home-page']);
  }

  resetFilter() {
    this.searchBar = '';
    localStorage.setItem('searchBar', this.searchBar);
    this._resetSidebar.passResetStatus('true');
    this.addProductItem('');
    this.homePageService.passCategoryId('');
    this.homePageService.passProductType('');
    this.homePageService.resetFilters( 'reset');
  }

  shopHomePage() {
    this.router.navigate(['/home-page']);
  }
}